import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
// import "./style/Session.css";
import { useContext, useEffect, useState } from "react";
import RelifeContactNew from "./homeLayout/RelifeContactNew";
import RelifeFooter from "./homeLayout/RelifeFooter";
import axios from "axios";
import { AuthContext } from "./auth/AuthProvider";
import LoadingSpinner from "./loadingSpinner/LoadingSpinner";
import Themes from "./themes/Themes";
import Animation from "./animation/Animation.jsx";
import RelifeClass from "./homeLayout/RelifeClass.jsx";

let br = 1;
export default function Session() {
  const [theme, setTheme] = useState([]);
  const [phase, setPhase] = useState({});
  const [question, setQuestion] = useState([]);

  const [loading, setLoading] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams();

  const [userProgress1, setUserProgress1] = useState([]);

  const {
    user,
    googleUser,
    userAnswer,
    googleUserAnswer,
    setPrevLocation,
    userProgress,
    setUserProgress,
    phase5Complete,
    setPhase5Complete,
    themeCompletion,
    setThemeCompletion,
    apiUrl,
  } = useContext(AuthContext);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    async function showThemes() {
      try {
        const res = await fetch(apiUrl + "/theme");

        const data = await res.json();

        setTheme(data.sort((a, b) => a.id - b.id));

        const res1 = await fetch(`${apiUrl}/phase/${1}`);

        const data1 = await res1.json();
        setPhase(data1);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }

    showThemes();

    setLoading(true);
    axios
      .get(`${apiUrl}/question/byTheme/love-and-disappointment`)
      .then((response) => {
        setQuestion(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });

    if (user) {
      setLoading(true);
      axios
        .get(`${apiUrl}/user-progress/username/${user.username}`)
        .then((response) => {
          setUserProgress(response.data.sort((a, b) => b.id - a.id));
        })
        .catch((e) => {
          setUserProgress(null);
        })
        .finally(() => {
          setLoading(false);
        });

      // axios
      //   .get(
      //     `http://localhost:8080/user-question/byUserAndTheme/${user.username}/${id}`,
      //   )
      //   .then((response) => {
      //     const sorted = response.data.sort(
      //       (a, b) => b.questionId - a.questionId,
      //     );
      //     setThemeCompletion(sorted[0]?.questionThemeIndex);
      //   });
    }

    if (googleUser) {
      setLoading(true);
      axios
        .get(`${apiUrl}/user-progress/googleEmail/${googleUser.email}`)
        .then((response) => {
          setUserProgress(response.data.sort((a, b) => b.id - a.id));
        })
        .catch((e) => {
          setUserProgress(null);
        })
        .finally(() => {
          setLoading(false);
        });

      // axios
      //   .get(
      //     `http://localhost:8080/user-question/byGoogleUserAndTheme/${googleUser.email}/${id}`,
      //   )
      //   .then((response) => {
      //     const sorted = response.data.sort(
      //       (a, b) => b.questionId - a.questionId,
      //     );
      //     setThemeCompletion(sorted[0]?.questionThemeIndex);
      //   });
    }
  }, [userAnswer]);

  useEffect(() => {
    if (theme.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("rotateElement", "relifeBookNow");
          observer.unobserve(entry.target);
        }
      });
    });

    const cards = document.querySelectorAll(".blog-card");
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, [theme]);

  // useEffect(() => {
  //   if (loading) return;

  //   if (!user && !googleUser) {
  //     localStorage.setItem("postLoginRedirect", location.pathname);
  //     navigate("/login", { replace: true });
  //   }
  // }, [loading, user, googleUser, navigate, location.pathname]);

  if (loading) {
    <LoadingSpinner />;
  }

  return (
    <>
      <RelifeClass
        leyebrow={"Guided journeys"}
        lh2={"Choose your theme"}
        lbody={"Start with whatever feels most true right now."}
      />

      <RelifeContactNew />
    </>
  );
}
